import { render, staticRenderFns } from "./_Stocks.vue?vue&type=template&id=087b673d&scoped=true&"
import script from "./_Stocks.vue?vue&type=script&lang=js&"
export * from "./_Stocks.vue?vue&type=script&lang=js&"
import style0 from "./_Stocks.vue?vue&type=style&index=0&id=087b673d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b673d",
  null
  
)

export default component.exports